export enum GET_PAGINATED_ORGANIZATION_TCES_WAITING_GRANTOR_SIGNATURE_COLUMNS {
  NAME = 'NAME',
  CPF = 'CPF',
  GROUP_NAME = 'GROUP_NAME',
  GROUP_CODE = 'GROUP_CODE',
  INTERNSHIP_LOCATION_NAME = 'INTERNSHIP_LOCATION_NAME',
  PERIOD = 'PERIOD',
  UPDATED_AT = 'UPDATED_AT',
}

export interface GetPaginatedOrganizationTcesWaitingGrantorSignatureParams {
  organizationHashId: string;
  page: number;
  length: number;
  courseHashIds?: string[];
  groupHashIds?: string[];
  search?: string;
  orderColumn?: GET_PAGINATED_ORGANIZATION_TCES_WAITING_GRANTOR_SIGNATURE_COLUMNS;
  orderDirection?: 'ASC' | 'DESC';
}
